"use client";
//#region packages/@mantine/core/src/core/utils/get-env/get-env.ts
function getEnv() {
	if (typeof process !== "undefined" && process.env && "development") return "development";
	return "development";
}
//#endregion
export { getEnv };

//# sourceMappingURL=get-env.mjs.map